import { getApiBase } from './config';

export type SessionStartSource = 'quick_reply' | 'user_message';

type RecordSessionStartPayload = {
  sessionId?: string | null;
  source: SessionStartSource;
  origin?: string;
};

export async function recordSessionStart(
  payload: RecordSessionStartPayload
): Promise<void> {
  const sessionId =
    typeof payload.sessionId === 'string' && payload.sessionId.trim().length > 0
      ? payload.sessionId.trim()
      : undefined;

  const body = {
    sessionId,
    source: payload.source,
    origin: payload.origin
  };

  const response = await fetch(`${getApiBase()}/analytics/session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(
      `Failed to record session start (${response.status}): ${text || response.statusText}`
    );
  }
}
